import { render, staticRenderFns } from "./cardinvest.vue?vue&type=template&id=296b1f3a&scoped=true"
import script from "./cardinvest.vue?vue&type=script&lang=js"
export * from "./cardinvest.vue?vue&type=script&lang=js"
import style0 from "./cardinvest.vue?vue&type=style&index=0&id=296b1f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b1f3a",
  null
  
)

export default component.exports